export default function SubscriptionCouponModel(dict) {
    this.fullImageUrl = dict.FullImageUrl;
    this.name = dict.Name;
    this.pointPerUnit = dict.PointPerUnit || null;
    this.serial = dict.Serial;
    this.voucherExpireDate = dict.VoucherExpireDate;
    this.redeemDate = dict.RedeemDate;
    this.isSubscriptionCoupon = true;
    this.barcode = 'QR_CODE';
    this.isUsed = dict?.IsUsed;
}